// ======================================================================
// File Name       : question
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../constants/actionTypes/question';
import { RETURN_MAX_NUM, NUM_ATTRIBUTE_QUESTION_SEARCH_MAX } from '../constants/index';
import { htmlEntities } from '../utils';
import { calculateTotalAbsolutePoint } from '../utils/ContentUtils';

const initialState = {
  questions: {
    bySecernId: {},
    allSecernIds: [],
  },
  filterData: {
    questionSecernId: '',
    questionTitle: '',
    answerFormula: null,
    convertStatus: null,
    questionKind: '-1',
    createdDateFrom: null,
    createdDateTo: null,
    dataAffiliationType: '-1',
    returnMaxNum: RETURN_MAX_NUM,
  },
  questionInfo: {
    questionId: null,
    questionKind: 0,
    questionSecernId: null,
    questionTitle: null,
    questionContent: null,
    questionUseForm: 0,
    answerFormula: 0,
    optionMarkKind: 0,
    inputLimitType: 0,
    optionRandomUse: 0,
    correctAnswer: null,
    correctNumber: 0,
    optionArray: [],
    subQuestionArray: [],
    questionViewDirection: 0,
    absolutePoint: 0,
    limitTime: 0,
    sankakuUseDistinct: 0,
  },
  attributeListData: {
    bySecernId: {},
    allSecernIds: [],
  },
  attributeListDataDialog: {
    eachQuestionAttributeList: [],
    recordNum: 0,
  },
  redirectToList: false,
  isExportSuccess: false,
  resultOK: false,
  questionImportedFiles: {},
  redirectToDetail: false,
  questionListInfo: {},
};

export default function question(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.QUESTION_LIST_SEARCH: {
      const { recordNum } = action;
      let { questionList } = action;
      let { questions } = state;
      if (!questionList || !questionList.length) {
        questionList = [];
      }
      questions = questionList.reduce(
          (acc, cur) => {
            const { questionSecernId } = cur;
            cur.questionTitle = htmlEntities(cur.questionTitle); // #6818
            // #7245 START
            if (cur.subQuestionArray) { // in case of big question
              cur.absolutePoint = calculateTotalAbsolutePoint(cur.subQuestionArray);
            }
            // #7245 END
            acc.bySecernId[questionSecernId] = cur;
            acc.allSecernIds.push(questionSecernId);
            return acc;
          },
        {
          bySecernId: {},
          allSecernIds: [],
          recordNum,
        },
      );
      return {
        ...state,
        redirectToList: false,
        ...{ questions },
        ...{ questionListInfo: action },
      };
    }
    case ActionTypes.EXPORT_QUESTION_LIST: {
      return {
        ...state,
        ...{ isExportSuccess: true },
      };
    }
    case ActionTypes.REGISTER_NEW_BIG_QUESTION: {
      return {
        ...state,
        ...{ redirectToList: true },
      };
    }
    case ActionTypes.REGISTER_NEW_SINGLE_QUESTION: {
      return {
        ...state,
        ...{ redirectToList: true },
      };
    }
    case ActionTypes.QUESTION_ATTRIBUTE_LIST: {
      const { recordNum, questionAttributeIdList } = action;
      const questionAttribute = questionAttributeIdList.reduce(
        (acc, cur) => {
          const { questionAttributeId } = cur;
          acc.bySecernId[questionAttributeId] = cur;
          acc.allSecernIds.push(questionAttributeId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );

      return {
        ...state,
        ...{ questionAttributeIdList, recordNum, doneRegister: false },
      };
    }
    case ActionTypes.QUESTION_ATTRIBUTE_PACKAGE_REGISTER: {
      return {
        ...state,
        ...{ doneRegister: true },
      };
    }
    case ActionTypes.CREATE_VALUE_ATTRIBUTE_ITEM: {
      const attributeOptions = {};
      const attributeText = {};
      const filterData = { ...state.filterData };
      for (let i = 1; i <= NUM_ATTRIBUTE_QUESTION_SEARCH_MAX; i++) {
        attributeOptions[`attribute${i}`] = '';
        attributeText[`attribute${i}`] = '';
      }
      filterData.attributeOptions = attributeOptions;
      filterData.attributeText = attributeText;
      return {
        ...state,
        filterData,
      };
    }
    case ActionTypes.QUESTION_DETAIL: {
      const { questionInfo } = action;
      state.questionInfo = questionInfo;
      return { ...state, ...{ questionInfo }, redirectToDetail: false };
    }
    case ActionTypes.QUESTION_UPDATE: {
      return {
        ...state,
        ...{ redirectToDetail: true },
      };
    }
    case ActionTypes.QUESTION_DELETE: {
      return {
        ...state,
        ...{ redirectToList: true },
      };
    }
    case ActionTypes.GET_IMPORTED_FILE_LIST: {
      const { recordNum, importResultList } = action;
      const questionImportedFiles = { recordNum, importResultList };
      return {
        ...state,
        ...{ questionImportedFiles },
      };
    }
    case ActionTypes.IMPORT_QUESTION_LIST: {
      return {
        ...state,
        ...{ resultOK: true },
      };
    }
    case ActionTypes.GET_ATTRIBUTE_LIST: {
      const { attributeList } = action;
      let attributeListData = {};
      if (attributeList && attributeList.questionAttributeIdList && attributeList.questionAttributeIdList.length) {
        attributeListData = attributeList.questionAttributeIdList.reduce((acc, cur) => {
          if (cur && cur.questionAttributeId) {
            acc.bySecernId[cur.questionAttributeId] = cur;
            acc.allSecernIds.push(cur.questionAttributeId);
          }
          return acc;
        }, {
          bySecernId: {},
          allSecernIds: [],
        });
      }
      return {
        ...state,
        attributeListData,
      };
    }
    case ActionTypes.GET_ATTRIBUTE_LIST_DIALOG: {
      const { attributeList } = action;
      let attributeListDataDialog = {};
      if (attributeList && attributeList.questionAttributeIdList && attributeList.questionAttributeIdList.length) {
        attributeListDataDialog = attributeList.questionAttributeIdList.reduce((acc, cur) => {
          if (cur && cur.questionAttributeId) {
            acc.eachQuestionAttributeList = cur.eachQuestionAttributeList;
            acc.recordNum = attributeList.recordNum;
          }
          return acc;
        }, {});
      }
      return {
        ...state,
        attributeListDataDialog,
      };
    }

    default:
      return {
        ...state,
        ...{
          redirectToList: false,
          isExportSuccess: false,
          resultOK: false,
          questionImportedFiles: {},
          redirectToDetail: false,
          recordNum: 0,
        },
      };
  }
}
